/**
 * A waiting service-worker update applies itself only when this tab is not
 * in the middle of capture work. `isRecordingActive` covers live recording,
 * pause, and the last-chunk upload at Stop — not the later SUMMARIZED poll.
 */
export function shouldApplyUpdate(pendingUpdate: boolean, isRecordingActive: boolean): boolean {
  return pendingUpdate && !isRecordingActive
}
